import type { PatientStrings } from '../index';

export const ta: PatientStrings = {
  titleOne: 'உங்கள் புதிய கிரவுன்',
  titleMany: 'உங்கள் புதிய கிரவுன்கள்',
  tooth: 'பல்',
  teeth: 'பற்கள்',
  both: 'இரண்டும்',
  overview: 'முழு காட்சி',
  front: 'முன்பக்கம்',
  leftSide: 'இடது பக்கம்',
  rightSide: 'வலது பக்கம்',
  bitingSurface: 'மெல்லும் பகுதி',
  show: 'காட்டு',
  newCrown: 'புதிய கிரவுன்',
  newCrowns: 'புதிய கிரவுன்கள்',
  yourTeeth: 'உங்கள் பற்கள் மற்றும் ஈறுகள்',
  upperTeeth: 'மேல் பற்கள்',
  lowerTeeth: 'கீழ் பற்கள்',
  hint: 'சுழற்ற இழுக்கவும் · பெரிதாக்க பிஞ்ச் அல்லது ஸ்க்ரோல் செய்யவும்',
  zoomIn: 'பெரிதாக்கு',
  zoomOut: 'சிறிதாக்கு',
  turnSlowly: 'மெதுவாகச் சுழற்று',
  stopTurning: 'சுழற்றுவதை நிறுத்து',
  backToStart: 'தொடக்கத்திற்கு',
  fullScreen: 'முழுத் திரை',
  exitFullScreen: 'முழுத் திரையிலிருந்து வெளியேறு',
  fromDentist: 'உங்கள் பல் மருத்துவரிடமிருந்து',
  shadeNote: (shade) =>
    `நிறம் ஏறக்குறைய ஷேட் ${shade} போலக் காட்டப்பட்டுள்ளது. உண்மையான கிரவுனின் நிறம் ஆய்வகத்தில் பொருத்தப்படும்.`,
  before: 'முன்',
  after: 'பின்',
  seeInRoom: 'உங்கள் அறையில் பாருங்கள்',
  arNotSupported: 'கிரவுனை உங்கள் அறையில் பார்க்க இந்தப் பக்கத்தை உங்கள் போனில் திறக்கவும்.',
  appointmentTitle: 'கிரவுன் பொருத்தும் உங்கள் சந்திப்பு',
  confirm: 'உறுதிசெய்',
  confirmed: 'உறுதியானது — அப்போது சந்திப்போம்',
  anotherTime: 'வேறு நேரம் கேளுங்கள்',
  anotherTimeSent: 'உங்களுக்கு வேறு நேரம் தேவை என்று உங்கள் பல் மருத்துவரிடம் தெரிவித்துள்ளோம்.',
  language: 'மொழி',
  largerText: 'பெரிய எழுத்து',
};
